const state = {
  profileInfoId: null,
  profileInfo: null,
  releaseDate: null,
};

const mutations = {
  SET_PROFILE_INFO: (state, profileInfo) => {
    state.profileInfo = profileInfo;
  },
  SET_PROFILE_INFO_ID: (state, profileInfoId) => {
    state.profileInfoId = profileInfoId;
  },
  SET_RELEASE_DATE: (state, releaseDate) => {
    state.releaseDate = releaseDate;
  },
};

const getters = {
  profileInfo: (state) => state.profileInfo,
  profileInfoId: (state) => state.profileInfoId,
  releaseDate: (state) => state.releaseDate,
};

const companyProfile = {
  state,
  getters,
  mutations,
};

export default companyProfile;
